import type { LocationModel } from '@/entities/location';
import type { MapReport, ReportValues } from '@/features/map-layers';

/** Legacy's five clustering levels (`mapping.js:331-361`). */
export const MAP_GROUP_BY = ['location', 'country', 'region', 'subregion', 'locationGroup'] as const;

export type MapGroupBy = (typeof MAP_GROUP_BY)[number];

/** One location with the value of every enabled report at the selected week. */
export interface ClusterSource {
  location: LocationModel;
  values: ReportValues;
}

export interface MapCluster {
  id: string;
  /** Location name, or the name of the country / region / subregion / location group. */
  name: string;
  lat: number;
  lng: number;
  values: ReportValues;
  /** Sum of every slice — drives the marker radius. */
  total: number;
  locations: LocationModel[];
}

export type ClusterNameResolver = (id: string) => string;

export type { MapReport };
